import React, { useEffect, useState } from 'react'
import Deletemodal from '../common/Modals/Deletemodal'
import Addmodal from '../common/Modals/Addmodal'
import { getCategory , getBrand, getType, Baseurl, getAuthor, getAllEmirates, getAllBoys} from '../../service/apiService'

const Masters = (props) => {
 const [activeTab, setActiveTab] = useState('home')
 const [category, setCategory] = useState([])
 const [author, setAuthor] = useState([])
 const [brand, setBrand] = useState([])
 const [type, setType] = useState([])
 const [deliverypersons, setDeliverypersons] = useState([])
 const [isModalOpen, setIsModalOpen] = useState(false);
 const [idtodelete, setiIdtodelete] = useState(false);
 const [refresh, setRefresh] = useState(false);
 const [show, setShow] = useState(false);
 const handleClose = () => setShow(false);
 const handleShow = () => setShow(true);
 const [emirates, setEmirates] = useState(false);
 const [editemirates, setEditemirates] = useState(false);

 const handleCloseEmr = () => setEmirates(false);
 const handleShowEmr= () => setEmirates(true);

 const handleCloseeditEmr = () => setEditemirates(false);
 const handleShoweditEmr= () => setEditemirates(true);

 const [editstring, setEditstring] = useState()
 const [brandmodal, setBrandmodal] = useState(false);
 const handleCloseBrand = () => setBrandmodal(false);
 const handleShowBrand = () => setBrandmodal(true);
 const [brandaddmodal, setBrandaddmodal] = useState(false);
 const handleCloseBrandAdd = () => setBrandaddmodal(false);
 const handleShowBrandAdd = () =>{ 
  setEditstring('brand')
  setBrandaddmodal(true)
};
const [emiratedata,setEmiratedata] = useState([])
  const [searchterm, setSearchterm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
      const [totalPages, setTotalPages] = useState(0);
 const [typemodal, setTypemodal] = useState(false);
 const handleClosetype = () => setTypemodal(false);
 const handleShowtype = () => setTypemodal(true);

 const [typeaddmodal, setTypeaddmodal] = useState(false);
 const handleCloseTypeAdd = () => setTypeaddmodal(false);
 const handleShowTypeAdd = () => setTypeaddmodal(true);

 const [authoraddmodal, setAuthoraddmodal] = useState(false);
 const handleShowAuthorAdd = () => setAuthoraddmodal(true);
 const handleCloseAuthorAdd = () => setAuthoraddmodal(false);
const [removemodal, setRemovemodal] = useState(false)

 const addAuthor = () => {
  setEditstring('author')
  handleShowAuthorAdd()
 } 

 const deleteAuthor = (id) => {
  setiIdtodelete(id);
  setEditstring('deleteauthor')
  setRemovemodal(!removemodal)
 } 

 const editAuthor = (id) => {
  setiIdtodelete(id);
  setEditstring('editauthor')
  handleShowAuthorAdd()
 }

 const addCategory = () => {
  setEditstring('category')
  handleShow()
 } 

 const addType = () => {
  handleShowTypeAdd()
 }

 const openModal = () => {
   setIsModalOpen(true);
 };
 const closeModal = () => {
   setIsModalOpen(false);
 };

 const CategoryData = async () => {
  let category =  await getCategory()
  setCategory(category?.data?.data)
  let brand = await getBrand(searchterm,currentPage)
  setBrand(brand.data.data)
  setTotalPages(brand.data.totalPages);
  let type = await getType()
  setType(type.data.data)
  let author = await getAuthor()
  setAuthor(author?.data?.data)

 }
 const deleteCategory = (id) => {
  setiIdtodelete(id);
  setEditstring('category')
  openModal()
 } 

 const editCategory = (id) => {
  setiIdtodelete(id);
  setEditstring('editcategory')
  handleShow()
 }

 const deleteBrand = (id) => {
  setiIdtodelete(id);
  setEditstring('brand')
  handleShowBrand()
 }
 
 const EditBrand = async (id) => {
  setiIdtodelete(id);
  handleShowBrandAdd()
   setEditstring('editbrand')
 
 }

 const deleteType = (id) => {
  setiIdtodelete(id);
  handleShowtype()
 }
 
 const editType = (id) => {
 return
 }
 const afterBrandDelete = async () => {
  let brand = await getBrand()
  setBrand(brand.data.data)
  handlePageChange(totalPages > 1 ? 1 : 0)
 }

 const afterBrandAdd = async () => {
  let brand = await getBrand()
  setBrand(brand.data.data)
  handlePageChange(totalPages > 1 ? 1 : 0)
 }

 const afterTypeDelete = async () => {
  let type = await getType()
  setType(type.data.data)
 }

 const afterTypeAdd = async () => {
  let type = await getType()
  setType(type.data.data)
 }

 const afterAuthorAddDelete = async () => {
   let author = await getAuthor()
  setAuthor(author.data.data)
 }

const getDelveryBoyDetails = async () => {
  let author = await getAllBoys()
  setDeliverypersons(author.data.data)
 }

 const addEmirates = () => {
  setEditstring('emirates')
 handleShowEmr()
 }
 const editEmirates = async (id) => {
  setiIdtodelete(id)
  setEditstring('editEmirates')
  handleShowEmr()
 } 
 const deleteEmirate = async (id) => {
  setiIdtodelete(id)
  setEditstring('deleteemirate')
  handleShoweditEmr()
 }
const parentRefresh = async () => {
  if(editstring === 'editEmirates'){
    await getEmirate()
  }
  if(editstring === 'emirates'){
    await getEmirate()
  }
  if(editstring === 'deleteemirate'){
    await getEmirate()
  }
  if(editstring === 'addboy' || editstring === 'editboy' || editstring === 'deleteboy'){
    await getDelveryBoyDetails()
  }
}

 const addDeliveryBoy = () => {
  setEditstring('addboy')
  handleShowEmr()
 } 

  const editDeliveryBoy = (id) => {
    setiIdtodelete(id)
  setEditstring('editboy')
  handleShowEmr()
 }

const deleteDeliveryBoy = (id) => {
  setiIdtodelete(id)
  setEditstring('deleteboy')
  setRemovemodal(!removemodal)
 }

 const initRefresh = () => {
  setRefresh(!refresh)
 }
 const getEmirate = async () => {
  let res = await getAllEmirates()
  setEmiratedata(res?.data)
 }

   const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo(0, 0);
  };

  const handleFirstPage = () => {
    setCurrentPage(1);
    window.scrollTo(0, 0);
  };

  const handleLastPage = () => {
    setCurrentPage(totalPages);
    window.scrollTo(0, 0);
  };

  
  const getPageNumbers = () => {
    const pageNumbers = [];
    const maxPagesToShow = 5; // Show 5 page numbers at a time
    
    let startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
    let endPage = startPage + maxPagesToShow - 1;
    
    if (endPage > totalPages) {
      endPage = totalPages;
      startPage = Math.max(1, endPage - maxPagesToShow + 1);
    }
    
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }
    
    return pageNumbers;
  };
useEffect(() =>  {
  ( async () => {
     let brand = await getBrand(searchterm,currentPage)
  setBrand(brand.data.data)
  setTotalPages(brand.data.totalPages);
  }
)() 
},[searchterm, currentPage])   
useEffect(()=>{
  (async ()=> {
    await CategoryData()
    await getEmirate()
  })()
},[refresh]) 

useEffect(()=>{
  (async ()=> {
    await getDelveryBoyDetails()
  })()
},[])
  return (
    <div>
                              <div class="right-content">
                           <div class="page-head d-flex justify-content-between align-items-center flex-wrap">
                             <h1>Master</h1> 

                           </div>
                           <div class="container-fluid p-0">
                             <div class="settings-tabs">
                              <div>
                                <ul class="nav nav-tabs">
                                  <li class="nav-item">
                                    <a className={`nav-link ${activeTab === 'home' ? 'active' : ''}`} data-bs-toggle="tab" href="#home" onClick={() => setActiveTab('home')}>
                                     <img src="/images/myprofile.svg" />  
                                     <div>
                                      <h6>BRAND</h6> 
                                     </div>     
                                    </a>
                                  </li>
                                  <li class="nav-item">
                                    <a className={`nav-link ${activeTab === 'menu1' ? 'active' : ''}`}  onClick={() => setActiveTab('menu1')}>
                                       <img src="/images/commission.svg" />  
                                     <div>
                                         <h6>Category</h6>  
                                     </div>  
                                    </a>
                                  </li>
                                  <li class="nav-item">
                                    <a className={`nav-link ${activeTab === 'menu2' ? 'active' : ''}`} onClick={() => setActiveTab('menu2')}>
                                      <img src="/images/Activitylog.svg" />  
                                     <div>
                                         <h6>Types</h6>
                                     </div>  
                                    </a>
                                  </li>
                                  <li class="nav-item">
                                    <a className={`nav-link ${activeTab === 'menu3' ? 'active' : ''}`} onClick={() => setActiveTab('menu3')}>
                                       <img src="/images/commission.svg" />  
                                     <div>
                                         <h6>Author</h6>  
                                     </div>  
                                    </a>
                                  </li>
                                  <li class="nav-item">
                                    <a className={`nav-link ${activeTab === 'menu4' ? 'active' : ''}`} onClick={() => setActiveTab('menu4')}>
                                       <img src="/images/commission.svg" />  
                                     <div>
                                         <h6>Region Rates</h6>  
                                     </div>  
                                    </a>
                                  </li>
                                    <li class="nav-item">
                                    <a className={`nav-link ${activeTab === 'menu5' ? 'active' : ''}`} onClick={() => setActiveTab('menu5')}>
                                       <img src="/images/commission.svg" />  
                                     <div>
                                         <h6>Delivery Boy</h6>  
                                     </div>  
                                    </a>
                                  </li>
                                  {/* <li class="nav-item">
                                    <a className={`nav-link ${activeTab === 'menu3' ? 'active' : ''}`} onClick={() => setActiveTab('menu3')}data-bs-toggle="tab" href="#menu3">
                                      <img src="assets/images/activity.svg" />  
                                     <div>
                                         <h6>Add Author</h6>
                                     </div>    
                                    </a>
                                  </li> */}
                                  {/* <li class="nav-item">
                                    <a class="nav-link" data-bs-toggle="tab" href="#menu4">
                                      <img src="assets/images/privacy.svg" />  
                                     <div>
                                         <h6>Privacy Policy</h6>
                                     </div>
                                    </a>
                                  </li>
                                  <li class="nav-item">
                                    <a class="nav-link" data-bs-toggle="tab" href="#menu5">
                                       <img src="assets/images/Faq.svg" />  
                                     <div>
                                         <h6>FAQ</h6>
                                     </div>  
                                    </a>
                                  </li>
                                  <li class="nav-item">
                                    <a class="nav-link" data-bs-toggle="tab" href="#menu6">
                                       <img src="assets/images/password.svg" />  
                                     <div>
                                         <h6>Change Password</h6>
                                     </div>  
                                    </a>
                                  </li> */}
                                  {/* <li class="nav-item">
                                    <a class="nav-link" href="#" data-bs-toggle="modal" data-bs-target="#logout">
                                       <img src="assets/images/logout.svg" />  
                                     <div>
                                         <h6>Logout</h6>
                                     </div>  
                                    </a>
                                  </li> */}
                                </ul> 
                               </div>
                                
                                 <div class="full">
                                <div class="tab-content h-100">
                                  <div  className={`tab-pane container ${activeTab === 'home' ? 'active' : 'fade'}`} id="home">
                                  <div className='text-white'>{ brandmodal ? <Deletemodal idtodelete={idtodelete} initRefresh={afterBrandDelete} isModalOpen={brandmodal} closeModal={handleCloseBrand} brand={editstring} /> : <></> }</div> 
                                  <div className='text-white'>{ brandaddmodal ? <Addmodal show={brandaddmodal} idtodelete={idtodelete} handleClose={handleCloseBrandAdd} brand={editstring} initRefresh={afterBrandAdd}  /> : <></> } </div> 
                                    <div class="card mb-4 bg-curve">
                                      <div class="d-flex justify-content-between card-head align-items-center">
                                        <h2 className="mt-3 text-white">Details of Brand</h2>
                                      <button className="tb-add-btn" onClick={handleShowBrandAdd}>AddBrand+</button>
                                                <div class="search-table">
                                <input type="text" value={searchterm} className="form-control text-white w-auto table-search" placeholder="Search" onChange={(e) => setSearchterm(e.target.value)} />
                              </div>
                                      </div>
                             
                                      <div class="table-responsive cmn-table dragscroll">
                                    <table class="w-100">
                                     <thead>
                                      <tr className='text-white'>  
                                      <th>Sl No.</th>   
                                      <th>Brand Name</th>
                                      <th>Edit</th>  
                                      <th>Delete</th>   
                                      <th width="250"></th>     
                                     </tr>
                                     </thead>
                                     <tbody className='w-100 text-white'>
                                      {brand.map((item,index) => {
                                        const serialNumber = (currentPage  - 1) * 10 + index + 1;
                                        return(
                                          <tr key={index}>
                                          <td>{serialNumber}</td> 
                                          <td><img src={`${Baseurl}/view/imageupload/${item.img}?t=${new Date().getTime()}`} class="user-img me-2" />{item?.name}</td>
                                          <td>
                                          <button class="act-btns" onClick={() => {EditBrand(item._id)}} ><i class="far fa-redo-alt"></i> Edit</button>  
                                          </td>
                                          <td>
                                          <button class="act-btns" onClick={() => {deleteBrand(item._id)}} ><i class="far fa-edit"></i> Delete</button>
                                          </td>
                                          <td></td>
                                      </tr>)
                                      })}
                                     </tbody>
                                    </table>
                                    </div>
                                    <div className="container mt-4">
          {totalPages > 0 && (
            <nav aria-label="Page navigation">
              <ul className="pagination justify-content-center">
                {/* First Page Button */}
                <li className={`page-item  ${currentPage === 1 ? 'disabled' : ''}`}>
                  <button 
                    className="page-link d-flex justify-content-center" 
                    onClick={handleFirstPage}
                    disabled={currentPage === 1}
                  >
                    First
                  </button>
                </li>
                
                {/* Previous Button */}
                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                  <button 
                    className="page-link d-flex justify-content-center " 
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    &laquo;
                  </button>
                </li>
                
                {/* Page Numbers */}
                {getPageNumbers().map(number => (
                  <li 
                    key={number} 
                    className={`page-item ${currentPage === number ? 'active' : ''}`}
                  >
                    <button
                      className="page-link d-flex justify-content-center "
                      onClick={() => handlePageChange(number)}
                    >
                      {number}
                    </button>
                  </li>
                ))}
                
                {/* Next Button */}
                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                  <button 
                    className="page-link d-flex justify-content-center " 
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  >
                    &raquo;
                  </button>
                </li>
                
                {/* Last Page Button */}
                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                  <button 
                    className="page-link d-flex justify-content-center " 
                    onClick={handleLastPage}
                    disabled={currentPage === totalPages}
                  >
                    Last
                  </button>
                </li>
              </ul>
            </nav>
          )}
    
    </div>
                                    </div> 
                                  </div>

                                  <div id='menu1' className={`tab-pane container ${activeTab === 'menu1' ? 'active' : 'fade'}`} >
                                  <div className='text-white'>{ isModalOpen ? <Deletemodal idtodelete={idtodelete} initRefresh={initRefresh} isModalOpen={isModalOpen} closeModal={closeModal} category={'category'} /> : <></> }</div> 
                                  <div className='text-white'>{ show ? <Addmodal show={show} idtodelete={idtodelete} handleClose={handleClose} category={editstring} initRefresh={initRefresh} /> : <></> } </div> 
                                    <div class="card mb-4 bg-curve">
                                      <div class="d-flex justify-content-between card-head align-items-center">
                                         <h2 className="mt-3 text-white">Details of Categories</h2>
                                         <button className="tb-add-btn" onClick={addCategory}>AddCategory+</button>
                                      </div>
                                      <div class="table-responsive cmn-table dragscroll">
                                    <table class="w-100">
                                     <thead>
                                      <tr className='text-white'>  
                                      <th>Sl No.</th>   
                                      <th>Category Name</th>
                                      <th>Edit</th>  
                                      <th>Delete</th>   
                                      <th width="250"></th>     
                                     </tr>
                                     </thead>
                                     <tbody className='w-100 text-white'>
                                      {category.map((item,index) => {
                                        return(
                                          <tr key={index}>
                                          <td>{index+1}</td>
                                          <td><img src={`${Baseurl}/view/imageupload/${item.img}?t=${new Date().getTime()}`} class="user-img me-2" />{item?.name}</td>
                                          <td>
                                              <button class="act-btns" onClick={() => {editCategory(item._id)}} ><i class="far fa-redo-alt"></i> Edit</button>  
                                          </td>
                                          <td>
                                          <button class="act-btns" onClick={() => {deleteCategory(item._id)}}><i class="far fa-edit"></i> Delete</button>
                                          </td>
                                          <td></td>
                                      </tr>)
                                      })}
                                     </tbody>
                                    </table>
                                    </div>
                                        {/* <nav aria-label="Page navigation">
                                      <ul class="pagination justify-content-end mt-3">
                                        <li class="page-item">
                                          <a class="page-link" href="#" aria-label="Previous">
                                            <span aria-hidden="true"><i class="fas fa-caret-left"></i></span>
                                          </a>
                                        </li>
                                        <li class="page-item active"><a class="page-link" href="#">1</a></li>
                                        <li class="page-item"><a class="page-link" href="#">2</a></li>
                                        <li class="page-item"><a class="page-link" href="#">3</a></li>
                                        <li class="page-item">
                                          <a class="page-link" href="#" aria-label="Next">
                                            <span aria-hidden="true"><i class="fas fa-caret-right"></i></span>
                                          </a>
                                        </li>
                                      </ul>
                                    </nav> */}
                                    </div> 
                                  </div> 

                                  <div id='menu2' className={`tab-pane container ${activeTab === 'menu2' ? 'active' : 'fade'}`} >
                                  <div className='text-white'>{ typemodal ? <Deletemodal idtodelete={idtodelete} initRefresh={afterTypeDelete} isModalOpen={typemodal} closeModal={handleClosetype} type={'type'} /> : <></> }</div> 
                                  <div className='text-white'>{ typeaddmodal ? <Addmodal show={typeaddmodal} handleClose={handleCloseTypeAdd} type={'type'} initRefresh={afterTypeAdd} /> : <></> } </div> 
                                    <div class="card mb-4 bg-curve">
                                      <div class="d-flex justify-content-between card-head align-items-center">
                                         <h2 className="mt-3 text-white">Details of Type</h2>
                                         {/* <button className="tb-add-btn" onClick={addType}>AddType+</button> */}
                                      </div>
                                      <div class="table-responsive cmn-table dragscroll">
                                    <table class="w-100">
                                     <thead>
                                      <tr className='text-white'>  
                                      <th>Sl No.</th>   
                                      <th>Name</th>
                                      {/* <th>Edit</th>  
                                      <th>Delete</th>    */}
                                      <th width="250"></th>     
                                     </tr>
                                     </thead>
                                     <tbody className='w-100 text-white'>
                                      {type.map((item,index) => {
                                        return(
                                          <tr key={index}>
                                          <td>{index+1}</td>
                                          <td>{item.name}</td>
                                          {/* <td>
                                              <button class="act-btns" onClick={() => {editType(item._id)}}><i class="far fa-redo-alt"></i> Edit</button>  
                                          </td> */}
                                          {/* <td>
                                          <button class="act-btns" onClick={() => {deleteType(item._id)}} ><i class="far fa-edit"></i> Delete</button>
                                          </td> */}
                                          <td></td>
                                      </tr>)
                                      })}
                                     </tbody>
                                    </table>
                                    </div>
                                        {/* <nav aria-label="Page navigation">
                                      <ul class="pagination justify-content-end mt-3">
                                        <li class="page-item">
                                          <a class="page-link" href="#" aria-label="Previous">
                                            <span aria-hidden="true"><i class="fas fa-caret-left"></i></span>
                                          </a>
                                        </li>
                                        <li class="page-item active"><a class="page-link" href="#">1</a></li>
                                        <li class="page-item"><a class="page-link" href="#">2</a></li>
                                        <li class="page-item"><a class="page-link" href="#">3</a></li>
                                        <li class="page-item">
                                          <a class="page-link" href="#" aria-label="Next">
                                            <span aria-hidden="true"><i class="fas fa-caret-right"></i></span>
                                          </a>
                                        </li>
                                      </ul>
                                    </nav> */}
                                    </div> 
                                  </div> 

                                  <div className={`tab-pane container ${activeTab === 'menu3' ? 'active' : 'fade'}`} id="menu3">
                                  <div className='text-white'>{ removemodal ? <Deletemodal idtodelete={idtodelete} initRefresh={afterAuthorAddDelete} isModalOpen={removemodal} closeModal={() => setRemovemodal(!removemodal)} from={editstring} /> : <></> }</div> 
                                  <div className='text-white'>{ authoraddmodal ? <Addmodal show={handleShowAuthorAdd} handleClose={handleCloseAuthorAdd} id={idtodelete} from={editstring} initRefresh={afterAuthorAddDelete} /> : <></> } </div> 
                                  <div class="card mb-4 bg-curve">
                                      <div class="d-flex justify-content-between card-head align-items-center">
                                         <h2 className="mt-3 text-white">Details of Author</h2>
                                         <button className="tb-add-btn" onClick={addAuthor}>AddAuthor+</button>
                                      </div>
                                      <div class="table-responsive cmn-table dragscroll">
                                    <table class="w-100">
                                     <thead>
                                      <tr className='text-white'>  
                                      <th>Sl No.</th>   
                                      <th>Author Name</th>
                                      <th>Edit</th>  
                                      <th>Delete</th>       
                                     </tr>
                                     </thead>
                                     <tbody className='w-100 text-white'>
                                      {author?.map((item,index) => {
                                        return(
                                          <tr key={index}>
                                          <td>{index+1}</td>
                                          <td> <img src={`${Baseurl}/view/imageupload/${item.img}?t=${new Date().getTime()}`} class="user-img me-2" /> {item.name}</td>
                                          <td>
                                              <button class="act-btns" onClick={() => editAuthor(item?._id)}><i class="far fa-redo-alt"></i> Edit</button>  
                                          </td>
                                          <td>
                                          <button class="act-btns" onClick={() => {deleteAuthor(item._id)}} ><i class="far fa-edit"></i> Delete</button>
                                          </td>
                                          <td></td>
                                      </tr>)
                                      })}
                                     </tbody>
                                    </table>
                                    </div>
                                        {/* <nav aria-label="Page navigation">
                                      <ul class="pagination justify-content-end mt-3">
                                        <li class="page-item">
                                          <a class="page-link" href="#" aria-label="Previous">
                                            <span aria-hidden="true"><i class="fas fa-caret-left"></i></span>
                                          </a>
                                        </li>
                                        <li class="page-item active"><a class="page-link" href="#">1</a></li>
                                        <li class="page-item"><a class="page-link" href="#">2</a></li>
                                        <li class="page-item"><a class="page-link" href="#">3</a></li>
                                        <li class="page-item">
                                          <a class="page-link" href="#" aria-label="Next">
                                            <span aria-hidden="true"><i class="fas fa-caret-right"></i></span>
                                          </a>
                                        </li>
                                      </ul>
                                    </nav> */}
                                    </div>  
                                  </div>

                                  <div className={`tab-pane container ${activeTab === 'menu4' ? 'active' : 'fade'}`} id="menu4">
                                  {/* <div className='text-white'>{ typemodal ? <Deletemodal idtodelete={idtodelete} initRefresh={afterTypeDelete} isModalOpen={typemodal} closeModal={handleClosetype} from={'author'} /> : <></> }</div>  */}
                                  <div className='text-white'>{ emirates ? <Addmodal show={handleShowEmr} handleClose={handleCloseEmr} id={idtodelete} from={editstring} initRefresh={parentRefresh} /> : <></> } </div> 
                                  {editemirates && editstring === 'deleteemirate' ? <Deletemodal idtodelete={idtodelete} initRefresh={parentRefresh} isModalOpen={editemirates && editstring === 'deleteemirate' } closeModal={handleCloseeditEmr} from={editstring}  /> : <></>}
                           
                                  <div class="card mb-4 bg-curve">
                                      <div class="d-flex justify-content-between card-head align-items-center">
                                         <h2 className="mt-3 text-white">Country / Emirates Name</h2>
                                         <button className="tb-add-btn" onClick={addEmirates}>Add+Country / Emirates</button>
                                      </div>
                                      <div class="table-responsive cmn-table dragscroll">
                                    <table class="w-100">
                                     <thead>
                                      <tr className='text-white'>  
                                      <th>Sl No.</th>   
                                      <th>Country / Emirate Name</th>
                                      <th>Price</th>
                                      <th>Edit</th>  
                                      <th>Delete</th>       
                                     </tr>
                                     </thead>
                                     <tbody className='w-100 text-white'>
                                      {emiratedata?.map((item,index) => {
                                        return(
                                          <tr key={index}>
                                          <td>{index+1}</td>
                                          <td>{item.name}</td>
                                          <td>{item.price}</td>

                                          <td>
                                              <button class="act-btns" onClick={() => editEmirates(item?._id)}><i class="far fa-redo-alt"></i> Edit</button>  
                                          </td>
                                          <td>
                                          <button class="act-btns" onClick={() => {deleteEmirate(item._id)}} ><i class="far fa-edit"></i> Delete</button>
                                          </td>
                                          <td></td>
                                      </tr>)
                                      })}
                                     </tbody>
                                    </table>
                                    </div>
                                        {/* <nav aria-label="Page navigation">
                                      <ul class="pagination justify-content-end mt-3">
                                        <li class="page-item">
                                          <a class="page-link" href="#" aria-label="Previous">
                                            <span aria-hidden="true"><i class="fas fa-caret-left"></i></span>
                                          </a>
                                        </li>
                                        <li class="page-item active"><a class="page-link" href="#">1</a></li>
                                        <li class="page-item"><a class="page-link" href="#">2</a></li>
                                        <li class="page-item"><a class="page-link" href="#">3</a></li>
                                        <li class="page-item">
                                          <a class="page-link" href="#" aria-label="Next">
                                            <span aria-hidden="true"><i class="fas fa-caret-right"></i></span>
                                          </a>
                                        </li>
                                      </ul>
                                    </nav> */}
                                    </div>  
                                  </div>

                                     <div className={`tab-pane container ${activeTab === 'menu5' ? 'active' : 'fade'}`} id="menu5">
                                  {/* <div className='text-white'>{ typemodal ? <Deletemodal idtodelete={idtodelete} initRefresh={afterTypeDelete} isModalOpen={typemodal} closeModal={handleClosetype} from={'author'} /> : <></> }</div>  */}
                                  <div className='text-white'>{ emirates ? <Addmodal show={handleShowEmr} handleClose={handleCloseEmr} id={idtodelete} from={editstring} initRefresh={parentRefresh} /> : <></> } </div> 
                                  <div className='text-white'>{ removemodal && editstring === 'deleteboy' ? <Deletemodal idtodelete={idtodelete} initRefresh={parentRefresh} isModalOpen={removemodal} closeModal={() => setRemovemodal(!removemodal)} from={editstring} /> : <></> }</div> 

                                  <div class="card mb-4 bg-curve">
                                      <div class="d-flex justify-content-between card-head align-items-center">
                                         <h2 className="mt-3 text-white">Delivery Boy</h2>
                                         <button className="tb-add-btn" onClick={addDeliveryBoy}>Add+ DeliveryBoy</button>
                                      </div>
                                      <div class="table-responsive cmn-table dragscroll">
                                    <table class="w-100">
                                     <thead>
                                      <tr className='text-white'>  
                                      <th>Sl No.</th>   
                                      <th>Name</th>
                                      <th>Email</th>
                                      <th>Mobile</th>
                                      <th>Edit</th>  
                                      <th>Delete</th>       
                                     </tr>
                                     </thead>
                                     <tbody className='w-100 text-white'>
                                      {deliverypersons?.map((item,index) => {
                                        return(
                                          <tr key={index}>
                                          <td>{index+1}</td>
                                          <td>{item?.name}</td>
                                          <td>{item?.email}</td>
                                          <td>{item?.mobile}</td>
                                          <td>
                                              <button class="act-btns" onClick={() => editDeliveryBoy(item?._id)}><i class="far fa-redo-alt"></i> Edit</button>  
                                          </td>
                                          <td>
                                          <button class="act-btns" onClick={() => {deleteDeliveryBoy(item._id)}} ><i class="far fa-edit"></i> Delete</button>
                                          </td>
                                          <td></td>
                                      </tr>)
                                      })}
                                     </tbody>
                                    </table>
                                    </div>
                                        {/* <nav aria-label="Page navigation">
                                      <ul class="pagination justify-content-end mt-3">
                                        <li class="page-item">
                                          <a class="page-link" href="#" aria-label="Previous">
                                            <span aria-hidden="true"><i class="fas fa-caret-left"></i></span>
                                          </a>
                                        </li>
                                        <li class="page-item active"><a class="page-link" href="#">1</a></li>
                                        <li class="page-item"><a class="page-link" href="#">2</a></li>
                                        <li class="page-item"><a class="page-link" href="#">3</a></li>
                                        <li class="page-item">
                                          <a class="page-link" href="#" aria-label="Next">
                                            <span aria-hidden="true"><i class="fas fa-caret-right"></i></span>
                                          </a>
                                        </li>
                                      </ul>
                                    </nav> */}
                                    </div>  
                                  </div>


                                  <div class="tab-pane container fade" id="menu3">
                                    <div class="card bg-curve">
                                      <div class="d-flex justify-content-between card-head align-items-center">
                                        <h2>TERMS AND CONDITIONS</h2>
                                        <a href="#" data-bs-toggle="modal" data-bs-target="#xv"><i class="far fa-edit"></i></a>
                                      </div>
                                      <p class="text-shade">But I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account of the system, and expound the actual teachings of the great explorer of the truth, the master-builder of human happiness. No one rejects, dislikes, or avoids pleasure itself, because it is pleasure, but because those who do not know how to pursue pleasure rationally encounter consequences that are extremely painful. </p>
                                      <p class="text-shade">There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable.</p>
                                      <p class="text-shade">There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable.</p>
                                    </div>   
                                  </div>
                                  <div class="tab-pane container fade" id="menu4">
                                    <div class="card bg-curve">
                                     <div class="d-flex justify-content-between card-head align-items-center">
                                        <h2>Privacy Policy</h2>
                                      </div>
                                      <p>Privacy Policy</p>
                                      <p>
Your privacy is important to Imperium. This privacy statement provides information about the personal information that Imperium collects, and the ways in which Imperium uses that personal information.
</p>
                                        <p>Personal information collection</p>
                                        <p>Imperium may collect and use the following kinds of personal information:</p>
                                        <p>information about your use of this website;</p>
                                        <p>information that you provide us for the purpose of registering with the website;</p>
                                        <p>information about transactions carried out over this website;</p>
    <p>information that you provide for the purpose of subscribing to the website services; and
        any other information that you send to Imperium.</p>

                                            
                                    </div>   
                                  </div>
                                  <div class="tab-pane container fade" id="menu5">
                                    <div class="card bg-curve">
                                      <div class="d-flex justify-content-between card-head align-items-center">
                                        <h2>FAQs</h2>
                                        <button class="btn cmm-btn"  data-bs-toggle="modal" data-bs-target="#faq">ADD +</button>                                      
                                      </div>
                                      <p>We get asked a lot of questions - most of which are similar. Hopefully our list of the more common questions will help you to find the information you want.</p>
                                      <div class="row">
                             <div class="col-lg-12">
                                <div class="accordion cm-accordion" id="accordionExample">
                                  <div class="accordion-item">
                                    <h2 class="accordion-header" id="headingOne">
                                      <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                        Why should I use a Personal Trainer?
                                      </button>
                                    </h2>
                                    <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                      <div class="accordion-body delete-edit-main">
                                        <div class="delete-edit">
                                           <a href="#"><i class="far fa-edit me-2"></i></a>  
                                           <a href="#"><i class="fas fa-trash-alt"></i></a>  
                                        </div>
                                       Some people are happy to follow their own programme in their own time and place; for those who lack the time, or the motivation, or the energy to train effectively on their own, a Personal Trainer can be the answer. The support, advice and encouragement comes with safe exercise technique to help you avoid injuries.
                                      </div>
                                    </div>
                                  </div>
                                  <div class="accordion-item">
                                    <h2 class="accordion-header" id="headingTwo">
                                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                        Why should I use a Personal Trainer?
                                      </button>
                                    </h2>
                                    <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                                      <div class="accordion-body delete-edit-main">
                                      <div class="delete-edit">
                                           <a href="#"><i class="far fa-edit me-2"></i></a>  
                                           <a href="#"><i class="fas fa-trash-alt"></i></a>  
                                        </div>
                                       Some people are happy to follow their own programme in their own time and place; for those who lack the time, or the motivation, or the energy to train effectively on their own, a Personal Trainer can be the answer. The support, advice and encouragement comes with safe exercise technique to help you avoid injuries.
                                      </div>
                                    </div>
                                  </div>
                                  <div class="accordion-item">
                                    <h2 class="accordion-header" id="headingTwo">
                                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#xcvcx" aria-expanded="false" aria-controls="xcvcx">
                                        Why should I use a Personal Trainer?
                                      </button>
                                    </h2>
                                    <div id="xcvcx" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                                      <div class="accordion-body delete-edit-main">
                                       <div class="delete-edit">
                                           <a href="#"><i class="far fa-edit me-2"></i></a>  
                                           <a href="#"><i class="fas fa-trash-alt"></i></a>  
                                        </div>
                                       Some people are happy to follow their own programme in their own time and place; for those who lack the time, or the motivation, or the energy to train effectively on their own, a Personal Trainer can be the answer. The support, advice and encouragement comes with safe exercise technique to help you avoid injuries.
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                                    </div>   
                                  </div>
                                  <div class="tab-pane container fade" id="menu6">
                                    <div class="card bg-curve">
                                      <div class="d-flex justify-content-between card-head align-items-center">
                                        <h2>Change PAssword</h2>
                                      </div>
                                      <h4>Enter a new password below to change your old password.</h4>
                                      <p>Password must have at least 8 characters,  lowercase, 1 uppercase, 1 number, and 1 special character.</p>
                                      <div class="row">
                                        <div class="col-lg-8">
                                          <div class="cm-form">
                                            <label>OLD PASSWORD</label>
                                            <input type="password" placeholder="************" class="form-control" />
                                            <label>ENTER NEW PASSWORD</label>
                                            <input type="password" placeholder="************" class="form-control" />
                                            <label>CONFIRM New PASSWORD</label>
                                            <input type="password" placeholder="************" class="form-control" />
                                            <button class="btn" data-bs-toggle="modal" data-bs-target="#submit-pass">SUBMIT PASSWORD</button>
                                          </div>
                                        </div>
                                      </div>
                                    </div> 
                                  </div>
                                </div>
                                 </div>
                             </div>
                           </div>  
                        </div>
    </div>
  )
}

export default Masters
